import React, { Fragment } from "react";
import { useState } from "react";
// Mui
import { Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

// Redux
import { getProfile } from "../../../reducer/profileSlice";
import { getEOCActive } from "../../../reducer/eocActiveSlice";
import { useSelector } from "react-redux";

// Components
import { getWeekOfYear } from "../../../function/WOY";
import ResponseDialog from "../ComponentReuse/ResponseDialog";
import EOCDetails from "../ComponentReuse/EOCDetails";

export default function EOCClose(props) {
    const { open, onClose, dataTitle, data, onSuccess } = props;
    const eocActive = useSelector(getEOCActive);
    const profile = useSelector(getProfile);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);

    const handleCloseResponse = () => {
        setModalResponse(false);
        onSuccess();
    };

    const handleCloseEOC = async () => {
        try {
            let dateNow = new Date();
            let woy = getWeekOfYear(dateNow);
            let dataSend = {
                eoc_id: eocActive?.eoc_id,
                closed_eoc_timestamp: dateNow.getTime().toString(),
                closed_eoc_week: woy.week,
                closed_eoc_year: woy.year,
                creator_id: profile?.inum,
                creator_name: profile?.displayName,
                org_id: profile?.org_id,
                org_name: profile?.org_name,
                phone: profile?.telephone,
                email: profile?.mail,
                remark: "",
            };
            const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/close_eoc`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataSend),
            });
            if (response.ok) {
                setStatus("ทำการปิด EOC เสร็จสิ้น");
                setModalResponse(true);
            } else {
                setStatus("ไม่สามารถปิด EOC ได้");
                setModalResponse(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleClose = () => {
        setStatus("");
        onClose();
    };

    return (
        <Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={open}
            >
                <DialogTitle className='py-3'>
                    <div>
                        <Typography variant="body1">ปิด {dataTitle?.org_level}</Typography>
                        <Typography variant="body2">
                            ท่านกำลังทำการปิด EOC
                        </Typography>
                    </div>
                </DialogTitle>
                <DialogContent className='md:px-16' dividers>
                    <EOCDetails eocData={eocActive} activityData={data} />
                </DialogContent>
                <DialogActions className='mx-4 my-2 gap-[10px]'>
                    <Button
                        onClick={handleCloseEOC}
                        variant="contained"
                        size="small"
                        style={{
                            backgroundColor: "#cd6c4a",
                        }}
                    >
                        ปิด EOC
                    </Button>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        size="small"
                        style={{
                            color: "#000",
                            borderColor: "#ccc",
                        }}
                    >
                        ปิด
                    </Button>
                </DialogActions>
            </Dialog>
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />
        </Fragment>
    );

}